import React, { type PropsWithChildren, useState } from "react";
import Collapsible from "react-collapsible";
import { spacing } from "../../../../../../../../stitches.config";
import { ButtonLink } from "../../../../../../../Common/ButtonLink";
import { Text, Textarea } from "../../../../../../../Inputs/react-hook-form";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../../form/form";
import { WidgetSettingsContainer } from "../__styles__/WidgetSettings";
import type { InputSettingsFormProps } from "../FieldSettingsView";

type AdvancedSettingsProps = Pick<
  InputSettingsFormProps,
  "fieldPath" | "isReadOnly"
>;

export function AdvancedSettings({
  fieldPath,
  isReadOnly,
}: AdvancedSettingsProps) {
  const { register } = useBuilderFormContext();

  return (
    <WidgetSettingsContainer>
      <Textarea
        label="File type description"
        disabled={isReadOnly}
        {...register(
          getUiSchemaPropertyFormPath(fieldPath, "fileTypeDescription"),
        )}
      />
      <Textarea
        label="File quantity description"
        disabled={isReadOnly}
        {...register(
          getUiSchemaPropertyFormPath(fieldPath, "fileQuantityDescription"),
        )}
      />
      <Textarea
        label="File size description"
        disabled={isReadOnly}
        {...register(
          getUiSchemaPropertyFormPath(fieldPath, "fileSizeDescription"),
        )}
      />
      <Text
        label="Document type abbreviation"
        disabled={isReadOnly}
        required
        {...register(
          getUiSchemaPropertyFormPath(fieldPath, "documentTypeAbbreviation"),
        )}
      />
      <Text
        label="Empty files message"
        disabled={isReadOnly}
        {...register(
          getUiSchemaPropertyFormPath(fieldPath, "emptyFilesMessage"),
        )}
      />
    </WidgetSettingsContainer>
  );
}

export function CollapsibleSection({ children }: PropsWithChildren<{}>) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible
      onOpen={() => setIsOpen(true)}
      onClosing={() => setIsOpen(false)}
      transitionTime={100}
      trigger={
        <div
          style={{
            pointerEvents: "none",
            marginTop: spacing.s.value,
          }}
        >
          <ButtonLink
            size="small"
            styleVariant="primary"
            href="#"
            rightIconName={isOpen ? "chevron-up" : "chevron-down"}
          >
            Advanced settings
          </ButtonLink>
        </div>
      }
    >
      {children}
    </Collapsible>
  );
}
